import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import statementStore from '../statement-store'
import statementUtils from './statement-utils'
import { IStatement } from '../../../model/statement'
import { Meta } from '../../../model/meta'
import authStore from '@/store/auth/auth-store';

export default async function fetchJybes(context: BareActionContext<StatementState, RootState>, statement: IStatement)
{
    statementUtils.statementService.getNumJybes(statement).then((numJybes: Meta<number>) => {
        // console.log('setting num jybes for index: ' + i + ': ' + numJybes.value)
        statementStore.commitSetNumJybes({ statement: statement, numJybes: numJybes.value })
    })
    if (authStore.isAuthenticated) {
        statementUtils.statementService.getIsJybed(statement).then((isJybed: Meta<boolean>) => {
            // console.log('setting num jybes for index: ' + i + ': ' + numJybes.value)
            statementStore.commitSetIsJybed({ statement: statement, isJybed: isJybed.value })
        })
    }

    return
}
